import Sidebar from "@/components/layout/Sidebar";
import { Toaster } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Key } from "@phosphor-icons/react";
import { useState } from "react";
import ChangePasswordDialog from "@/components/common/ChangePasswordDialog";
import NotificationBell from "@/components/layout/NotificationBell";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useNavigate } from "react-router-dom";

export default function AppShell({ children, title, subtitle, actions }) {
  const { user, logout } = useAuth();
  const [pwOpen, setPwOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-slate-50">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <header className="sticky top-0 z-30 backdrop-blur-md bg-white/85 border-b border-slate-200">
          <div className="flex items-center justify-between pl-16 lg:pl-6 pr-4 lg:pr-6 py-3 lg:py-4 gap-3">
            <div className="min-w-0">
              <h1 className="font-heading text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 tracking-tight truncate">
                {title}
              </h1>
              {subtitle && <p className="text-[11px] sm:text-xs text-slate-500 mt-0.5 line-clamp-1">{subtitle}</p>}
            </div>
            <div className="flex items-center gap-2 lg:gap-3 shrink-0">
              {actions}
              <NotificationBell />
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button data-testid="user-menu-btn" className="hidden md:flex items-center gap-2 pl-3 border-l border-slate-200 hover:opacity-80 transition-opacity">
                    <div className="w-8 h-8 rounded-full bg-slate-900 text-sky-400 flex items-center justify-center text-xs font-heading font-bold">
                      {(user?.name || user?.email || "U").charAt(0).toUpperCase()}
                    </div>
                    <div className="leading-tight text-left">
                      <div className="text-[13px] font-semibold text-slate-800">{user?.name}</div>
                      <div className="text-[10px] uppercase tracking-wider text-slate-500">{user?.role}</div>
                    </div>
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                  <DropdownMenuItem onClick={() => setPwOpen(true)} data-testid="menu-change-password">
                    <Key size={14} weight="duotone" className="mr-2" /> Ganti Password
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={async () => { await logout(); navigate("/login"); }} data-testid="menu-logout">
                    Keluar
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </header>
        <div className="flex-1 px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8 fade-up">
          {children}
        </div>
        <Toaster richColors position="top-right" />
        <ChangePasswordDialog open={pwOpen} onClose={() => setPwOpen(false)} />
      </main>
    </div>
  );
}
